import { render, staticRenderFns } from "./ProductEight.vue?vue&type=template&id=4137bf2e&"
import script from "./ProductEight.vue?vue&type=script&lang=js&"
export * from "./ProductEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4137bf2e')) {
      api.createRecord('4137bf2e', component.options)
    } else {
      api.reload('4137bf2e', component.options)
    }
    module.hot.accept("./ProductEight.vue?vue&type=template&id=4137bf2e&", function () {
      api.rerender('4137bf2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductEight.vue"
export default component.exports